import Popup, { ToolbarItem } from "devextreme-react/popup";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachment } from "../types/FileAttachment";
import FileAttachmentGrid from "./FileAttachmentGrid";
import './FileAttachmentsButton.scss'

export default function FileAttachmentsPopup(props:
	{
		attachedFiles: FileAttachment[]
		orderID?: number,
		parentGuid: string,
		kindOfOrder: KindOfOrder,
		orderTypeID?: number,
		defaultFileType?: FileTypes
		fileTypeFilter?: (fileType: FileTypes) => boolean,
		useFileTypes: boolean,
		hideDeleteButton?: boolean,
		replaceFile?: boolean,
		onFileAdded: (fileType: FileTypes) => void,
		onFileDeleted: () => void,
		onPopupHidden: () => void,
		visible: boolean
	}) {
	return (
		<Popup
			title="File Attachments"
			visible={props.visible}
			hideOnOutsideClick={true}
			onHiding={() => { props.onPopupHidden(); }}
		>
			<ToolbarItem
				options={{
					icon: 'dx-icon dx-icon-close',
					onClick: () => props.onPopupHidden()
				}}
				widget="dxButton"
				location="after"
			/>

			{
				props.visible &&
				<FileAttachmentGrid
					attachedFiles={props.attachedFiles}
					orderID={props.orderID}
					parentGuid={props.parentGuid}
					kindOfOrder={props.kindOfOrder}
					orderTypeID={props.orderTypeID}
					defaultFileType={props.defaultFileType}
					fileTypeFilter={props.fileTypeFilter}
					useFileTypes={props.useFileTypes}
					hideDeleteButton={props.hideDeleteButton}
					replaceFile={props.replaceFile}
					visible={props.visible}
					onFileAdded={props.onFileAdded}
					onFileDeleted={props.onFileDeleted}
				/>
			}

		</Popup>
	)
}
